import { Dispatch } from "redux";
import IAction from "../models/IAction";
import { toUnknownAction } from "./ReduxUtility";

/**
 * Helper function to dispatch IAction as UnknownAction
 * This wraps the toUnknownAction conversion for cleaner code
 */
export function dispatchAction<T>(dispatch: Dispatch, action: IAction<T>): void {
  dispatch(toUnknownAction(action));
}
